import { render, staticRenderFns } from "./BudgetsListFilters.vue?vue&type=template&id=b474a2f0&"
import script from "./BudgetsListFilters.vue?vue&type=script&lang=js&"
export * from "./BudgetsListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports